import React from 'react';
import '../../styles/Template1.css';
import logo from '../../uploads/logo.png';
import avatar from '../../uploads/avatar.png';
import earth from '../../uploads/earth.png';
import warning from '../../uploads/warning.jpg';

const Template1 = ({ formData, educationData, languageData, computerSkillsData, employmentData, relativesData, shiftWorkReady, legalIssues, coursesData, registrationAddress }) => {
    const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
	let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name.charAt(0).toUpperCase() + formData.BirthPlace.Country.Name.slice(1).toLowerCase() : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
    const reversedEmploymentData = employmentData.slice().reverse();
    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }

    const isObjectEmpty = (data) => {
        for (const item of data) {
            for (const key in item) {
                if (typeof item[key] === 'object') {
                    const subItem = item[key];
                    for (const subKey in subItem) {
                        if (subItem[subKey] !== '') {
                            return false;
                        }
                    }
                } else if (item[key] !== '') {
                    return false;
                }
            }
        }
        return true;
    };

	return (
		<>
		<div className="template1-container">
            <img src={logo} style={{ height: '11.4mm', opacity: '.6' }} alt='logo' />
            {<h1 className='center'>{formData.Name ? formData.Name : 'ФИО'}</h1>}
            <div className='template1-header'>
                <img src={imageUrl} className='avatar' alt='avatar' />
                <table className='template1-table' style={{ position: 'relative' }}>
                    <tbody>
                        <tr>
                            <td width={'50%'}><p>Дата рождения: {formData.BirthDate ? formatDate(formData.BirthDate) : ''}</p></td>
                            <td width={'50%'}><p>Место рождения: {birthPlace}</p></td>
                        </tr>
                        <tr>
                            <td><p>Контактные телефоны: {formData.MobilePhoneWork.value}</p></td>
                            <td><p>Почтовый адрес: {formData.EmailPersonal}</p></td>
                        </tr>
                        <tr>
                            <td><p>Адрес: {registrationAddress.ViewAddresses}</p></td>
                            <td><p>Семейное положение: {formData.MaritalStatus.Name}</p></td>
                        </tr>
                        <tr>
                            <td><p>Паспортные данные: {formData.Passport.DocSeries} {formData.Passport.DocNumber}</p></td>
                            <td><p style={{ textTransform: 'capitalize' }}>Гражданство: {formData.Citizenship.Name.toLowerCase()}</p></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/* <hr /> */}
            <p style={{ marginTop: '35px', display: 'block', fontSize: '11pt' }}>О себе</p>
            <h4 className='template1-title' style={{ marginTop: '20px' }}>ОПЫТ РАБОТЫ</h4>
            <div className='employment-box' >
                {!isObjectEmpty(reversedEmploymentData) && reversedEmploymentData.map((employment, index) => (
                    <div className='employment-row' key={`emp${index}`}>
                        <h5 style={{ fontSize: '12pt' }}>{employment.Position}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{employment.Organization} | {formatDate(employment.EmploymentDate)} - {employment.DismissalDate ? formatDate(employment.DismissalDate) : 'Н.В.'}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{employment.Duties}</h5><br/>
                    </div>                    
                ))}
            </div>
            <h4 className='template1-title' style={{ marginTop: '35px' }}>ОБРАЗОВАНИЕ</h4>
            <div className='education-box' >
                {!isObjectEmpty(educationData) && educationData.map((edu, index) => (
                    <div className='education-row' key={`edu${index}`}>
                        <h5 style={{ fontSize: '12pt' }}>{edu.Institution.Name}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{edu.Speciality.Name} | {edu.DocSeries+edu.DocNumber}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{formatDate(edu.Start)} - {formatDate(edu.End)}</h5>
                    </div>
                ))}
            </div>
            <div className='flex-education-box'>
                <div>
                    <h4 className='template1-title' style={{ marginBottom: '15px' }}>ЗНАНИЕ ЯЗЫКОВ</h4>
                    {!isObjectEmpty(languageData) && languageData.map((lang, index) => (
                        <p style={{ fontSize: '11pt', color: '#000' }} className='language-row' key={`lang${index}`}>{lang.Language.Name} - {lang.LanguageDegree.Name}</p>                    
                    ))}
                </div>
                <div>
                    <h4 className='template1-title' style={{ marginBottom: '15px' }}>КОМПЬЮТЕРНАЯ ГРАМОТНОСТЬ</h4>
                    {!isObjectEmpty(computerSkillsData) && computerSkillsData.map((skill, index) => (
                        <p style={{ fontSize: '11pt', color: '#000' }} className='computer-skill-row' key={`comp${index}`}>{skill.Software.Name} - {skill.SoftwareLevel.Name}</p>
                    ))}
                </div>
            </div>
            <h4 className='template1-title' style={{ marginTop: '35px' }}>ПОВЫШЕНИЕ КВАЛИФИКАЦИИ, СТАЖИРОВКИ, ТРЕНИНГИ, СЕМИНАРЫ</h4>
            <div className='courses-box' >
                {!isObjectEmpty(coursesData) && coursesData.map((course, index) => (
                    <div className='course-row' key={`course${index}`} style={{ marginTop: '16px' }}>
                        <p style={{ fontSize: '12pt' }}>С {course.StartDate ? formatDate(course.StartDate) : ''} ПО {course.EndDate ? formatDate(course.EndDate) : ''}</p><br />
                        <p style={{ fontWeight: 'bold', fontSize: '12pt' }}>{course.Name}</p>
                    </div>
                ))}
            </div>
            <table style={{ marginTop: '20px' }}>
                <tbody>
                    <tr>
                    <th colSpan="5">
                        <p className="center b">Сведения о близких родственниках</p>
                    </th>
                    </tr>
                    <tr>
                        <th width={"15%"}><p className="center b">Степень родства</p></th>
                        <th width={"17.5%"}><p className="center b">Ф.И.О.</p></th>
                        <th width={"17.5%"}><p className="center b">Дата и место рождения</p></th>
                        <th width={"25%"}><p className="center b">Должность и место работы</p></th>
                        <th width={"25%"}><p className="center b">Адрес</p></th>
                    </tr>
                    {relativesData.map((relative, index) => (
                    <tr key={`rel${index}`}>
                        <td><p className='center'>{relative.RelationshipDegree.Name}</p></td>
                        <td><p className='center'>{relative.Name}</p></td>
                        <td><p>{relative.BirthPlace_Country.Name.charAt(0).toUpperCase() + relative.BirthPlace_Country.Name.slice(1).toLowerCase()}<br/>{formatDate(relative.BirthDate)}</p></td>
                        <td><p>{relative.Position}<br />{relative.WorkPlace}</p></td>
                        <td><p>{relative.ResidencePlace}</p></td>              
                    </tr>   
                    ))}
                </tbody>
            </table>       
            <table style={{ marginTop: '16px' }}>
                <tbody>
                    <tr>
                    <th colSpan="2">
                        <p className="center b">Дополнительные сведения</p>
                    </th>
                    </tr>
                    <tr>
                    <td width="70%"><p className="b">Готовность к вахтовому режиму работы?</p></td>
                    <td width="30%"><p>{shiftWorkReady ? 'Да' : 'Нет'}</p></td>
                    </tr>
                    <tr>
                    <td><p className="b">Привлекались ли Вы к административной или уголовной ответственности?</p></td>
                    <td><p>{legalIssues ? 'Да' : 'Нет'}</p></td>
                    </tr>
                </tbody>
            </table>
            <div>
                <p style={{ marginTop: '20px', display: 'block', textAlign: 'justify' }}>
                    <i>
                    Настоящим я подтверждаю достоверность предоставленной информации и не возражаю против проверки предоставленных сведений.<br />
                    Мен ушбу хужат билан берилган маълумотларнинг тўғрилигини тасдиқлайман ва берилган маълумотларнинг текширилишига эътироз билдирмайман.<br />
                    Men ushbu hujat bilan berilgan ma'lumotlarning to'g'riligini tasdiqlayman va berilgan ma'lumotlarning tekshirilishiga e'tiroz bildirmayman
                    </i>
                </p>
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '32px'}}><p><i>Дата/Sana «____» ________202__ й</i></p><p><i>Подпись/Imzo   ___________________</i></p></div>
            </div>
            <img src={earth} className='footer' alt='footer' />
        </div>
		</>
	);
};

export default Template1;
